import { SocialAuthService } from '@abacritt/angularx-social-login';
import { Component } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';
import { HotToastService } from '@ngxpert/hot-toast';
import { BehaviorSubject } from 'rxjs';
import { ApiService } from 'src/libs/api/api.service';
import { AuthService } from 'src/libs/auth/auth.service';
import { LoginHeaderService } from 'src/libs/state/login-header.service';

@Component({
  selector: 'fini-login-forgot',
  templateUrl: './login-forgot.component.html',
  styleUrls: ['./login-forgot.component.scss'],
  standalone: false,
})
export class LoginForgotComponent {
  constructor(
    private api: ApiService,
    private router: Router,
    private toast: HotToastService,
    private social: SocialAuthService,
    private route: ActivatedRoute,
    private header: LoginHeaderService,
  ) {
    // Push header data up the tree
    this.header.set({
      title: 'Forgot Password',
      subtitle: 'So... you forgot your password eh?',
    });
  }

  loading$ = new BehaviorSubject(false);
  email = '';

  requestPasswordReset() {
    this.loading$.next(true);
    this.api.post('reset/request', { email: this.email }).subscribe((res) => {
      if (!res.success) {
        this.toast.error(res.message);
        this.loading$.next(false);
        return;
      }
      this.toast.success('Password reset email sent! Check your inbox.');
      this.router.navigate(['/reset-password']);
    });
    this.loading$.next(false);
  }
}
